import React from "react";
import Valper from "./Valper";
import Foreldre from "./Foreldre";

const SoeskenSammeKull = (props) => {
    const kull = props.kull;
    return (
        <div>
            <div className="splitt-title">
                Samme kuld
            </div>

            <Valper valper={kull.valper} />
            <Foreldre far={kull.far} mor={kull.mor} labelFar="FAR" labelMor="MOR" />
        </div>
    );
};

export default SoeskenSammeKull;